import {
  DepositIcon,
  MoreOne,
  TradeIcon,
  TransferData,
  WithdrawIcon,
} from "assets/Icon";
import { Grid, IconButton, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import BookmarkCoin from "components/BookmarkCoin";
import NumberFormats from "components/NumberFormats";
import Price from "./components/Price";
import SrcCoin from "./components/SrcCoin";
import StockNumber from "components/StockNumber";
import Table from "components/Table";
import WalletActions from "components/WalletActions";
import useIsMobileView from "hooks/useIsMobileView";
import { ROUTE_PATHS } from "routes/paths";

const headers = [
  {
    key: "isFavorite",
    name: "Favorite",
    align: "left",
    sortable: true,
    sortKey: "isFavorite",
  },
  {
    key: "srcCoin",
    align: "left",
    name: "Src / Dst",
    sortable: true,
    sortKey: "coinSourceName",
  },
  {
    key: "buy",
    align: "left",
    name: "Buy / Sell",
    sortable: true,
    sortKey: "priceBuy",
  },
  {
    key: "changePCT24HourBuy",
    align: "left",
    name: "Change(24h)",
    sortable: true,
    sortKey: "changePCT24HourBuy",
  },
  {
    key: "high24HourBuy",
    align: "left",
    name: "High(24h)",
    sortable: true,
    sortKey: "high24HourBuy",
  },
  {
    key: "low24HourBuy",
    align: "left",
    name: "Low(24h)",
    sortable: true,
    sortKey: "low24HourBuy",
  },
  {
    key: "actions",
    align: "center",
    name: "Actions",
  },
];

const headersMobile = [
  {
    key: "srcCoin",
    align: "left",
    sortable: true,
    name: "Coin",
    sortKey: "coinSourceName",
  },
  {
    key: "buy",
    align: "left",
    sortable: true,
    name: "Price",
    sortKey: "priceBuy",
  },
  {
    key: "changePCT24HourBuy",
    align: "left",
    sortable: true,
    name: "24hChg",
    sortKey: "changePCT24HourBuy",
  },
];

export function TableMarket({ marketList, setMarketList }) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const [showWalletAction, setShowWalletAction] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState(null);

  const handleShowWalletAction = (data) => {
    setSelectedCoin(data);
    setShowWalletAction(true);
  };

  const formattedDataList = marketList?.map((data, index) => {
    return {
      data: data,
      isFavorite: <BookmarkCoin data={data} />,
      srcCoin: <SrcCoin data={data} />,
      buy: <Price data={data} />,
      changePCT24HourBuy: (
        <StockNumber
          value={data?.changePCT24HourBuy}
          isBoxView={isMobileView}
          hasArrows={!isMobileView}
        />
      ),
      high24HourBuy: (
        <Typography variant="h6" fontWeight="400" color="text.main">
          <NumberFormats
            displayType={"text"}
            value={parseFloat(data.high24HourBuy)}
          />
        </Typography>
      ),
      low24HourBuy: (
        <Typography variant="h6" fontWeight="400" color="text.main">
          <NumberFormats
            displayType={"text"}
            value={parseFloat(data.low24HourBuy)}
          />
        </Typography>
      ),
      actions: (
        <IconButton color="text" onClick={() => handleShowWalletAction(data)}>
          <MoreOne color={theme.palette.text.secondary} />
        </IconButton>
      ),
    };
  });

  const handleClickRow = (e) => {
    if (isMobileView) {
      const rowData = e?.data;

      navigate(ROUTE_PATHS.trade.basic(rowData.coinSourceId, rowData.coinDestinationId));
    }
  };

  const walletActionItems = [
    {
      icon: (
        <WithdrawIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Withdraw",
      onClick: (data) => navigate(`/withdraw/${data.coinSourceId}`),
    },
    {
      icon: (
        <DepositIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Deposit",
      onClick: (data) => navigate(`/deposit/${data.coinSourceId}`),
    },
    {
      icon: (
        <TradeIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Trade",
      onClick: (data) =>
        navigate(ROUTE_PATHS.trade.basic(data.coinSourceId, data.coinDestinationId)),
    },
    {
      icon: <TransferData color={theme.palette.secondary.main} />,
      text: "Transfer",
      onClick: (data) => {
        setSearchParams({
          transfer: data?.coinSourceId,
          transferSideId: 2,
        });
      },
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table
          onRowClick={handleClickRow}
          headers={isMobileView ? headersMobile : headers}
          items={formattedDataList}
        />

        <WalletActions
          items={walletActionItems}
          open={showWalletAction}
          coin={selectedCoin}
          setCoin={setSelectedCoin}
          onClose={() => {
            setShowWalletAction(false);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TableMarket;
